import React, { Component } from 'react';

import RatingsSplit from './ratingsSplit'
import moment from 'moment';
import { opdbGTM } from '../../utils/pulseUtils';



class RatingsDetails extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    opdbGTM.routeLevelRatingsPage()
  }
  getCurrentRatingData(content,data){
    let currentRatingData= {};
    let totalRatingCount =0 ;
    let ratingsBreakUp=[];
    currentRatingData.headingTitle = 'Current Rating';
    currentRatingData.starHeadingTitle = 'Current Ratings Split (%)'; 
    currentRatingData.headingRating = data.average_rating;
    currentRatingData.headingRatingColor = data.color_code;
    for (let key in content.ratings_breakup){
      totalRatingCount = totalRatingCount + content.ratings_breakup[key + ''];
    }
    for(let i =5 ;i>=1;i--){
      let value = content.ratings_breakup[i + ''];
      ratingsBreakUp.push({
        stars : i,
        value: value ? `${((value / totalRatingCount) * 100).toFixed(1)}%` : '0%'
      });
    }
    currentRatingData ={
      ...currentRatingData,
      totalRatingCount , 
      ratingsBreakUp
    }
    return currentRatingData;
  }
  getfifteenDayRatingData(content) {
    let fifteenDayRatingData = {};
    let totalRatingCount = 0;
    let ratingsBreakUp = [];
    fifteenDayRatingData.headingTitle = 'Ratings 15 days back';
    fifteenDayRatingData.starHeadingTitle = 'Last 5 Ratings';
    fifteenDayRatingData.headingRating = content.last_fifteen_average;
    fifteenDayRatingData.headingRatingColor = content.color_code;
    for (let i = 0; i < content.last_five_ratings.length; i++) {
      let value = content.last_five_ratings[i];
      ratingsBreakUp.push({
        stars: value.rating,
        value: value.rating
      });
    }
    fifteenDayRatingData = {
      ...fifteenDayRatingData,
      totalRatingCount: content.last_fifteen_count,
      ratingsBreakUp
    }
    return fifteenDayRatingData;
  }
  getTagsByUsers(content){
    this.questionsTagDictionary={};
    let questionBlocks=content.question_details.map((question)=>
    { 
      let widthPercent = (question.score /5) *100;
      let remainingWidth = 100 - widthPercent;
      let barStyle={
        background: question.color_code,
        width: `${widthPercent}%`
      }
      let remainingBarStyle={
        width: `${remainingWidth}%`
      }
      if (!this.questionsTagDictionary[question.id]){
        this.questionsTagDictionary[question.id] = question.name;
      }
      return (
          <div className="tagby-users-block">
            <div className="tagby-users-left">{question.name}</div>
            <div className="tagby-users-right">
              <div className="tagby-users-rating-bar">
              <div className="tagby-users-actual-bar" style={barStyle}></div>
              <div className="tagby-users-remaining-bar" style={remainingBarStyle}></div>
              </div>
              <div className="tagby-users-rating-value">{question.score}</div>
            </div>
          </div>
        )
    })
    return questionBlocks;
  }
  render() {
    const { detailsPayload } = this.props;
    const {data,content}=detailsPayload;
    const { reviews } = content;
    const currentRatingData = this.getCurrentRatingData(content,data);
    const fifteenDayRatingData = this.getfifteenDayRatingData(content, data);
    return (
      <div className="col-xs-12 payout-content">
        <div className="rating-split-header">
          <span className="details-card-title">{data.paytm_source_name} - {data.paytm_dest_name}, {data.bus_type} {data.first_boarding_time}</span>
        </div>
        <div className="row search-row">
          <div className="ratings-split-wrapper">
            <div className="ratings-split-left">
              <RatingsSplit starsRenderObj={currentRatingData}/>
            </div>
            <div className="ratings-split-right">
              <RatingsSplit starsRenderObj={fifteenDayRatingData} />
            </div>
          </div>

          <div className="tagby-users">
            <div className="rating-split-header"><span className="details-card-title">Tags by Users</span></div>
            {this.getTagsByUsers(content)}
          </div>
        </div>
        {reviews && <div className="ratings-content review-content">
          <div className="rating-split-header"><span className="details-card-title">Passenger Reviews</span></div>
          <table className="app-table" >
            <thead>
              <tr className="ratings-table-header">
                <th>Passenger</th>
                <th>DOJ </th>
                <th>Rating</th>
                <th>Bus Tags</th>
                <th>Review</th>
              </tr>
            </thead>
            <tbody onClick={(event) => this.showRouteRatingsDetails(event)}>
              {
                !reviews.length && <tr><td colSpan={9} className="table-no-data">No Data Found</td></tr>
              }
              {
                reviews.map((el, i) => {
                  let colorCode, styles;
                  colorCode = el.color_code;
                  styles = { color: colorCode };
                   
                  return (
                    <tr key={i} className="ratings-table-row" index={i}>
                      <td className="reveiwer-name">{el.passenger}</td>
                      <td>{moment(el.travel_date).format('ll')}</td>
                      <td style={styles}>{el.rating}</td>
                      <td>{(el.question_ids.map((id) => this.questionsTagDictionary[id])).join(',')}</td>
                      <td>{el.review}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>}
      </div>
    )
  }

}

export default RatingsDetails;